














































































































































import { Component, Mixins, Watch } from 'vue-property-decorator';
import { withParams } from 'vuelidate';
import { and, minLength, required, sameAs } from 'vuelidate/lib/validators';
import {
  getMessage,
  isUserFriendlyEmail,
  mailValidator,
  validStateMachine,
} from '@/tools/validators';
import { Form, FormInput, Select } from '@/pages/profile/blocks';
import { Button, MainHeader } from '@/pages/profile/components';
import { Info, Message } from '../settings/components';
import { validateFioData } from '@/mixins/validateFioData';
import { SettingsMixin } from '../../mixins';
import { validateFio } from '@/tools/validatefio';
import { validateSnils } from '@/tools/validateSnils';
import { ACTIONS } from '@/store/user';
import { ISettins, OptionsType } from './types';
import {
  EMAIL_FORMAT_ERROR,
  EMAIL_REQUIRED_ERROR,
  FORM_ERROR_MESSAGE,
  FORM_SUCCESS_MESSAGE,
  GENDERS,
  PHONE_MASK,
  SNILS_ERROR_EMPTY,
  SNILS_ERROR_FORMAT,
  SNILS_MASK,
} from './consts';

@Component({
  components: {
    MainHeader,
    Form,
    FormInput,
    Select,
    Info,
    Message,
    Button,
  },

  mixins: [validateFioData],
})
export default class General extends Mixins(SettingsMixin) implements ISettins {
  genderOptions: typeof GENDERS = GENDERS;
  phoneMask: Array<any> = PHONE_MASK;
  snilsMask: Array<any> = SNILS_MASK;
  messageText = '';
  isPassLoading = false;
  errorColor = false;
  passwords: any = {
    newPassword: '',
    comparePassword: '',
  };

  get dateMask() {
    return [/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/];
  }

  get rolesOptions() {
    const { roles } = this.state;
    return roles
      ? roles.map(({ name, id }: OptionsType) => ({
          text: name,
          value: id,
        }))
      : [];
  }

  get levelOptions() {
    const { eduLevels } = this.state;
    return eduLevels
      ? eduLevels.map(({ name, id }: OptionsType) => ({
          text: name,
          value: id,
        }))
      : [];
  }

  get passChanged() {
    return this.passwords.newPassword !== '';
  }

  get canChangeEmail() {
    const { is_verified } = this.profile;
    return is_verified;
  }

  get correctUpdateEmail() {
    return this.messageText === FORM_SUCCESS_MESSAGE;
  }

  get infoText() {
    const { messageText, text } = this;
    return messageText.length ? messageText : text;
  }

  get snilsErrorText() {
    return !this.user.snils ? SNILS_ERROR_EMPTY : SNILS_ERROR_FORMAT;
  }

  get isDisabled() {
    if (this.$v.$invalid) return true;
    const { changed, passChanged } = this;
    return !changed && !passChanged;
  }

  get isErrorColor() {
    return this.color || this.errorColor;
  }

  get emailErrorText() {
    const { v } = this;
    return v.email.required ? EMAIL_FORMAT_ERROR : EMAIL_REQUIRED_ERROR;
  }

  get changed() {
    const { user, profile, v } = this;
    if (v.$invalid) return false;
    return JSON.stringify(user) !== JSON.stringify(this.parceProfile(profile));
  }

  @Watch('profile', { immediate: true })
  resetUser() {
    this.reset();
  }

  @Watch('changed')
  isChangeUserData(value: boolean) {
    this.$emit('changed');
    if (this.messageText.length) {
      this.messageText = '';
    }
  }

  @Watch('passwords', { deep: true })
  isChangePassword(value: any) {
    const { newPassword, comparePassword } = value;
    if (newPassword.length || comparePassword.length) {
      this.messageText = '';
    }
  }

  validStateMachine = validStateMachine;
  getMessage = getMessage;

  getMessageByInsertedEmail(value: string) {
    return value.replace(/.*@/, '');
  }

  validations() {
    const getMessageByInsertedEmail = (value: string) => {
      if (value) {
        return value.replace(/.*@/, '');
      } else {
        return '';
      }
    };
    const problemEmails =
      this.$store.state.regionProfile.constants.problem_email_domains;
    const isVerified = this.$store.state.user.profile.is_verified;
    const user: any = {
      first_name: {
        required,
        validateFio,
      },

      last_name: {
        required,
        validateFio,
      },

      email: {
        required: withParams({ $message: 'Укажите email' }, required),
        mailValidator: withParams(
          { $message: 'Укажите корректный email' },
          mailValidator
        ),
        isUserFriendlyEmail: withParams(
          {
            $message: (value: string) =>
              isVerified
                ? `Уведомления не направляются на адреса с доменом ${getMessageByInsertedEmail(
                    value
                  )}. Обратитесь в учреждение ДО для смены e-mail.`
                : `Уведомления не направляются на адреса с доменом ${getMessageByInsertedEmail(
                    value
                  )}. Укажите другой адрес.`,
          },
          isUserFriendlyEmail(
            !problemEmails
              ? problemEmails
              : problemEmails.filter((el) => el !== 'gmail.com')
          )
        ),
      },

      phone: {
        required,
        and: and((value: any) =>
          /^\+7 \([1-9]\d\d\) \d\d\d-\d\d-\d\d$/.test(value)
        ),
      },

      snils: {
        validateSnils,
      },

      birthday: {
        required: withParams({ $message: 'Укажите дату рождения' }, required),
        mask: and(
          (value: any) =>
            RegExp(
              `^\\s*(3[01]|[12][0-9]|0?[1-9])\\.(1[012]|0?[1-9])\\.(19[2-9][0-9]|20${this.getStrRegxPatternBeforeCurrentYear()})\\s*$`
            ).test(value ? value : '30.08.1990') // 30.08.1990 заглушка
        ),
      },
      edu_level_id: {
        required,
        and: and((value: any) => {
          return +value;
        }),
      },
      sex: {
        required,
        and: and((value: any) => {
          return !!value;
        }),
      },
    };

    if (this.user && this.user.patro_name) {
      user.patro_name = { validateFio };
    }

    const passwords: any = {
      newPassword: {
        minLength: minLength(6),
      },
      comparePassword: {
        sameAsPassword: sameAs('newPassword'),
      },
    };

    return { user, passwords };
  }

  resetPass() {
    (this as any).$v.passwords.$reset();
    this.passwords.newPassword = '';
    this.passwords.comparePassword = '';
  }

  allReset() {
    this.reset();
    this.resetPass();
  }

  submitPassword() {
    (this as any).$v.passwords.$touch();
    if ((this as any).$v.passwords.$invalid) {
      return;
    }

    this.isPassLoading = true;
    this.$store
      .dispatch(`user/${ACTIONS.CHANGE_PASSWORD}`, this.passwords.newPassword)
      .then(() => {
        this.messageText = FORM_SUCCESS_MESSAGE;
        this.isPassLoading = false;
        this.resetPass();
      })
      .catch(() => {
        this.errorColor = true;
        this.isPassLoading = false;
        this.messageText = FORM_ERROR_MESSAGE;
      });
  }

  saveProfile() {
    const { changed, passChanged } = this;
    if (changed) this.submit();
    if (passChanged) this.submitPassword();
  }

  parceProfile(value: any) {
    return {
      first_name: value!.first_name || '',
      last_name: value!.last_name || '',
      patro_name: value!.patro_name || '',
      snils: value!.snils || '',
      phone: value!.phone || '',
      email: value!.email || '',
      birthday: value!.birthday || '',
      sex: value!.sex || '',
      edu_level_id: value!.edu_level_id || '',
      work: value!.work || '',
      position: value!.position || '',
    };
  }

  reset() {
    this.v.$reset();
    this.user = this.profile ? this.parceProfile(this.profile) : {};
    (this as any).$v.user.$touch();
  }

  getStrRegxPatternBeforeCurrentYear() {
    function getCurrentYearByOctetIndex(index: any) {
      const curYear = new Date().getFullYear().toString().split('');
      return curYear[index];
    }
    const rex = `([0-1][\\d]|2[0-${getCurrentYearByOctetIndex(3)}])`;
    return rex;
  }
  mounted() {
    (this as any).$v.user.birthday.$touch();
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/general/General.vue